const getGrupo = async () => {
  return [
    {
      idGrupoMangueras: 1,
      nombre: "LIVIANO",
    },
    {
      idGrupoMangueras: 2,
      nombre: "PESADOS",
    },
  ];
};

const GrupoMangueras = {
  getGrupo,
};

export default GrupoMangueras;
